(function(){
  var API = window.AluConfig.api;
  if(!API||API.length<8){ console.warn('Alumenarc: Set Railway URL in section settings'); }
  else { API=API.replace(/\/+$/,''); }

  var EJS_SVC  = window.AluConfig.ejsSvc;
  var EJS_TPL  = window.AluConfig.ejsTpl;
  var EJS_KEY  = window.AluConfig.ejsKey;
  var HQ_EMAIL = window.AluConfig.hqEmail;
  var SHOW_EMAIL = window.AluConfig.showEmail;
  var SHOW_PROOF = window.AluConfig.showProof;
  var PROOF_BASE = window.AluConfig.proofBase;
  var PRODUCT_URL = window.AluConfig.productUrl;
  var SIZES_RAW   = window.AluConfig.sizesRaw;
  var SHOW_ATC    = window.AluConfig.showAtc;

  /* ════════════════════════════════════════════════
     PIXEL ANIMATION — tunable settings
     ════════════════════════════════════════════════ */
  var CFG_PIXEL_STEP        = 3;
  var CFG_PIXEL_GLOW        = 5;
  var CFG_BRIGHTNESS_THRESH = 35;
  var CFG_REVEAL_SECS       = 7;
  var CFG_NODE_COUNT        = 80;
  var CFG_LINK_DIST         = 35;
  var _pixelRaf=null, _pixels=[], _nodes=[], _revealStart=null;
  var _msgInterval=null, _logLines=[], _msgIdx=0;
  var IMG_KB=0;

  /* Close all dropdowns except the one passed in */
  function closeAllDropdowns(except){
    document.querySelectorAll('.alu-dd-btn.open').forEach(function(b){
      if(!except||!except.contains(b)){
        b.classList.remove('open');
        var l=b.parentNode.querySelector('.alu-dd-list');
        if(l)l.classList.remove('open');
      }
    });
  }
  /* Close dropdowns when clicking outside */
  document.addEventListener('click',function(){closeAllDropdowns(null);});

  var MSGS = {
    fetch:   ['Preparing your images','Reading image data','Analysing pixels'],
    connect: ['Connecting to render pipeline','Opening real-time channel','Synchronising'],
    build:   ['Mapping texture coordinates','Calculating surface normals','Applying metallic shader',
              'Extruding poster geometry','Baking light maps','Generating UV atlas',
              'Processing material layers','Rendering glossy surface','Rendering matte surface'],
    unpack:  ['Decompressing 3D assets','Parsing GLB binary','Loading geometry'],
    ready:   ['Models ready — drag to explore','Pinch to zoom on mobile']
  };

  function _$(id){return document.getElementById(id);}
  function calcEta(kb,pct){ return Math.max(0, Math.round((4+kb*0.006)*(1-pct/100))); }

  function updatePixelEta(pct){
    var el=_$('aluPixelEta'),val=_$('aluPixelEtaVal'),unit=_$('aluPixelEtaUnit'),sub=_$('aluPixelEtaSub');
    if(!el||IMG_KB<=0||pct>=98){if(el)el.classList.remove('show');return;}
    el.classList.add('show');
    var eta=calcEta(IMG_KB,pct);
    val.textContent=eta>60?Math.round(eta/60):eta;
    unit.textContent=eta>60?'MIN LEFT':'SEC LEFT';
    sub.textContent='est. from '+IMG_KB+'KB';
    var r=eta/calcEta(IMG_KB,0);
    if(r<.25){val.style.color='#00ff9f';val.style.textShadow='0 0 14px rgba(0,255,159,.5)';}
    else if(r<.6){val.style.color='#ae6fff';val.style.textShadow='0 0 14px rgba(174,111,255,.5)';}
    else{val.style.color='#00d4ff';val.style.textShadow='0 0 14px rgba(0,212,255,.5)';}
  }

  function cyclePixelMsg(phase){
    clearInterval(_msgInterval); _msgIdx=0;
    var ph=_$('aluPixelPhase'); if(ph) ph.textContent=phase.toUpperCase();
    var msgs=MSGS[phase]||[phase];
    function show(){
      var el=_$('aluPixelMsg'); if(!el)return;
      el.style.opacity='0';
      setTimeout(function(){ el.textContent=msgs[_msgIdx%msgs.length]; el.style.opacity='1'; _msgIdx++; },200);
    }
    show(); _msgInterval=setInterval(show,2800);
  }

  function addPixelLog(msg,cls){
    var el=_$('aluPixelLog'); if(!el)return;
    _logLines.push({m:msg,c:cls||'dim'});
    if(_logLines.length>3)_logLines.shift();
    el.innerHTML=_logLines.map(function(l,i){
      return '<span class="ln '+l.c+'" style="opacity:'+(0.3+i/_logLines.length*.7).toFixed(2)+'">'+l.m+'</span>';
    }).join('');
  }

  function setPixelProgress(pct){
    var bar=_$('aluPixelBar'),pctEl=_$('aluPixelPct');
    if(bar) bar.style.width=pct+'%';
    if(pctEl) pctEl.textContent=pct+'%';
    updatePixelEta(pct);
  }

  function getPosterBounds(){
    var wrap=_$('aluPixelCanvasWrap'); if(!wrap)return null;
    var cv=_$('aluPixelCanvas'); if(!cv)return null;
    var wr=wrap.getBoundingClientRect(), cvr=cv.getBoundingClientRect();
    if(wr.width===0)return null;
    var zW=wr.width, zH=wr.height, ph=zH*.72, pw=ph*.75;
    return{x:zW/2-pw/2, y:(wr.top-cvr.top)+(zH-ph)/2, w:pw, h:ph};
  }

  function buildPixelMap(imgEl){
    var b=getPosterBounds(); if(!b) return;
    var pw=Math.round(b.w), ph=Math.round(b.h);
    var oc=document.createElement('canvas'); oc.width=pw; oc.height=ph;
    oc.getContext('2d').drawImage(imgEl,0,0,pw,ph);
    var id=oc.getContext('2d').getImageData(0,0,pw,ph).data;
    var step=CFG_PIXEL_STEP;
    _pixels=[];
    for(var y=0;y<ph;y+=step) for(var x=0;x<pw;x+=step){
      var i=(y*pw+x)*4;
      var br=0.299*id[i]+0.587*id[i+1]+0.114*id[i+2];
      if(br>CFG_BRIGHTNESS_THRESH) _pixels.push({
        nx:x/pw, ny:y/ph, brightness:br/255,
        phase:Math.random()*Math.PI*2,
        speed:(Math.random()*.01+.004), born:0
      });
    }
    for(var j=_pixels.length-1;j>0;j--){var k=Math.floor(Math.random()*(j+1));var t=_pixels[j];_pixels[j]=_pixels[k];_pixels[k]=t;}
    _pixels.forEach(function(p,i){p.born=i/_pixels.length;});
    var N=Math.min(CFG_NODE_COUNT,_pixels.length);
    var s2=Math.max(1,Math.floor(_pixels.length/N));
    _nodes=[];
    for(var i=0;i<_pixels.length&&_nodes.length<N;i+=s2)_nodes.push(_pixels[i]);
    _revealStart=Date.now();
  }

  function startPixelCanvas(){
    var cv=_$('aluPixelCanvas'); if(!cv)return;
    var ctx=cv.getContext('2d');
    cv.width=cv.offsetWidth; cv.height=cv.offsetHeight;
    if(!_revealStart)_revealStart=Date.now();
    function tick(){
      _pixelRaf=requestAnimationFrame(tick);
      var W=cv.width, H=cv.height;
      ctx.clearRect(0,0,W,H);
      var b=getPosterBounds(); if(!b)return;
      var elapsed=Date.now()-_revealStart;
      var reveal=Math.min(1, elapsed/(CFG_REVEAL_SECS*1000));
      var outA=Math.max(0,Math.min(1,(reveal-.5)/.2));
      if(outA>0){
        var bL=13,x0=b.x,y0=b.y,x1=b.x+b.w,y1=b.y+b.h;
        ctx.lineWidth=1; ctx.strokeStyle='rgba(0,212,255,'+(outA*.55)+')';
        [[x0+bL,y0,x0,y0,x0,y0+bL],[x1-bL,y0,x1,y0,x1,y0+bL],[x0+bL,y1,x0,y1,x0,y1-bL],[x1-bL,y1,x1,y1,x1,y1-bL]].forEach(function(c){
          ctx.beginPath();ctx.moveTo(c[0],c[1]);ctx.lineTo(c[2],c[3]);ctx.lineTo(c[4],c[5]);ctx.stroke();
        });
        ctx.setLineDash([3,7]); ctx.strokeStyle='rgba(0,212,255,'+(outA*.1)+')';
        ctx.strokeRect(b.x,b.y,b.w,b.h); ctx.setLineDash([]);
      }
      for(var a=0;a<_nodes.length;a++){
        if(_nodes[a].born>reveal)continue;
        var ax=b.x+_nodes[a].nx*b.w, ay=b.y+_nodes[a].ny*b.h;
        for(var bb=a+1;bb<_nodes.length;bb++){
          if(_nodes[bb].born>reveal)continue;
          var bx=b.x+_nodes[bb].nx*b.w, by2=b.y+_nodes[bb].ny*b.h;
          var dx=ax-bx,dy=ay-by2,dist=Math.sqrt(dx*dx+dy*dy);
          if(dist<CFG_LINK_DIST){
            var lp=.25+(Math.sin((_nodes[a].phase+_nodes[bb].phase)/2)*.5+.5)*.75;
            var la=(1-dist/CFG_LINK_DIST)*.13*lp*(_nodes[a].brightness+_nodes[bb].brightness)/2;
            var gr=ctx.createLinearGradient(ax,ay,bx,by2);
            gr.addColorStop(0,'rgba(0,212,255,'+la+')');
            gr.addColorStop(.5,'rgba(174,111,255,'+(la*.55)+')');
            gr.addColorStop(1,'rgba(0,212,255,'+la+')');
            ctx.strokeStyle=gr; ctx.lineWidth=.5;
            ctx.beginPath(); ctx.moveTo(ax,ay); ctx.lineTo(bx,by2); ctx.stroke();
          }
        }
      }
      var glowR=CFG_PIXEL_GLOW;
      for(var i=0;i<_pixels.length;i++){
        var p=_pixels[i]; if(p.born>reveal)continue;
        p.phase+=p.speed;
        var pulse=.18+(Math.sin(p.phase)*.5+.5)*.82;
        var alpha=pulse*p.brightness;
        var px=b.x+p.nx*b.w, py=b.y+p.ny*b.h;
        if(alpha>.07){
          var grd=ctx.createRadialGradient(px,py,0,px,py,glowR);
          grd.addColorStop(0,'rgba(0,212,255,'+(alpha*.5)+')');
          grd.addColorStop(1,'rgba(0,212,255,0)');
          ctx.fillStyle=grd; ctx.beginPath(); ctx.arc(px,py,glowR,0,Math.PI*2); ctx.fill();
        }
        ctx.fillStyle='rgba(0,212,255,'+(Math.min(alpha*1.4,1))+')';
        ctx.beginPath(); ctx.arc(px,py,1.2,0,Math.PI*2); ctx.fill();
        if(alpha>.5){ctx.fillStyle='rgba(255,255,255,'+(alpha*.45)+')';ctx.beginPath();ctx.arc(px,py,.4,0,Math.PI*2);ctx.fill();}
      }
    }
    tick();
  }

  function stopPixelCanvas(){ if(_pixelRaf){cancelAnimationFrame(_pixelRaf);_pixelRaf=null;} }

  function showPixelOverlay(){
    var el=_$('aluPixelOverlay');
    el.classList.remove('fade');
    el.classList.add('show');
  }

  function hidePixelOverlay(){
    var el=_$('aluPixelOverlay');
    el.classList.add('fade');
    setTimeout(function(){
      el.classList.remove('show');
      el.classList.remove('fade');
      stopPixelCanvas();
      clearInterval(_msgInterval);
      _logLines=[];
    }, 750);
  }

  function sendEmail(params){
    console.log('sendEmail → to:', params.to_email, '| SVC:', EJS_SVC, '| TPL:', EJS_TPL, '| KEY len:', (EJS_KEY||'').length);
    if(!EJS_SVC || EJS_SVC.length < 5 || !EJS_TPL || EJS_TPL.length < 5 || !EJS_KEY || EJS_KEY.length < 5){
      console.error('EmailJS not configured — check section settings. SVC='+EJS_SVC+' TPL='+EJS_TPL);
      return Promise.resolve();
    }
    return new Promise(function(resolve, reject){
      function go(){
        try{
          window.emailjs.init({publicKey:EJS_KEY});
          window.emailjs.send(EJS_SVC,EJS_TPL,params,EJS_KEY)
            .then(function(r){ console.log('EmailJS OK status:',r.status); resolve(r); })
            .catch(function(e){ console.error('EmailJS error:',JSON.stringify(e)); reject(e); });
        }catch(ex){ console.error('EmailJS exception:',ex); reject(ex); }
      }
      if(window.emailjs){go();return;}
      var s=document.createElement('script');
      s.src='https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
      s.onload=go; document.head.appendChild(s);
    });
  }

  /* Social proof */
  if(SHOW_PROOF && API && API.length>8){
    fetch(API+'/stats',{mode:'cors',credentials:'omit'})
      .then(function(r){return r.json();})
      .then(function(d){
        var el=document.getElementById('aluProofNum');
        if(!el)return;
        var live=(d.generated||0)+PROOF_BASE;
        var start=PROOF_BASE, dur=1400, t0=Date.now();
        function tick(){
          var p=Math.min(1,(Date.now()-t0)/dur);
          var e=1-Math.pow(1-p,3);
          el.textContent=Math.round(start+(live-start)*e).toLocaleString();
          if(p<1)requestAnimationFrame(tick);
        }
        tick();
      })
      .catch(function(){});
  }

  var sizeSel=document.getElementById('aluSizeSel');
  if(sizeSel && SIZES_RAW){
    SIZES_RAW.split('\n').forEach(function(s){
      s=s.trim(); if(!s)return;
      var o=document.createElement('option'); o.value=s; o.textContent=s;
      sizeSel.appendChild(o);
    });
  }

  var S={g:true,m:true,file:null,files:[],origFiles:[],busy:false};
  var _mv=null,_mvUrl=null,_sse=null,_sid=null,_timer=null,_t0=null;
  var _env='https://modelviewer.dev/shared-assets/environments/aircraft_workshop_01_1k.hdr';

  function $(id){return document.getElementById(id);}
  function fmt(b){return b<1024000?Math.round(b/1024)+'KB':(b/1048576).toFixed(1)+'MB';}

  function toast(msg,ok){
    var t=$('aluToast'),d=$('aluTdot');
    $('aluTmsg').textContent=msg;
    var c=(ok===false)?'var(--er)':'var(--ok)';
    d.style.background=c;d.style.boxShadow='0 0 8px '+c;
    t.classList.add('on');clearTimeout(t._h);
    t._h=setTimeout(function(){t.classList.remove('on');},3500);
  }

  function log(msg,cls){
    var el=$('aluLog'),lines=el.querySelectorAll('.alu-log-line');
    if(lines.length>=4)lines[0].remove();
    var d=document.createElement('div');
    d.className='alu-log-line'+(cls?' '+cls:'');
    d.textContent=msg;el.appendChild(d);
  }

  function stopTimer(){clearInterval(_timer);_timer=null;_t0=null;}

  var dz=$('aluDz');
  $('aluFile').addEventListener('change',function(e){
    if(e.target.files.length)setFiles(e.target.files);
    e.target.value='';
  });
  ['dragenter','dragover'].forEach(function(ev){
    dz.addEventListener(ev,function(e){e.preventDefault();dz.classList.add('over');});
  });
  dz.addEventListener('dragleave',function(){dz.classList.remove('over');});
  dz.addEventListener('drop',function(e){
    e.preventDefault();dz.classList.remove('over');
    var imgs=Array.from(e.dataTransfer.files).filter(function(f){
      return f.type.startsWith('image/')||/\.(png|jpe?g|webp|heic|heif)$/i.test(f.name);
    });
    if(imgs.length)setFiles(imgs);
  });
  document.addEventListener('paste',function(e){
    var items=Array.from((e.clipboardData||{}).items||[]);
    var item=items.find(function(i){return i.type.startsWith('image/');});
    if(!item)return;e.preventDefault();
    var f=item.getAsFile();
    if(f)setFiles([new File([f],'pasted.png',{type:f.type})]);
  });

  var MAX_SEND_PX  = 3072;
  var MAX_SEND_MB  = 10;
  var JPEG_QUALITY = 0.88;

  function _prepareFile(f, cb){
    var isHeic=/\.(heic|heif)$/i.test(f.name||'')||
               f.type==='image/heic'||f.type==='image/heif';
    var needsCompress=f.size > MAX_SEND_MB*1024*1024;
    if(!isHeic && !needsCompress){ cb(f); return; }
    if(isHeic) log('Converting HEIC: '+f.name+'…','hi');
    else log('Compressing '+fmt(f.size)+' → sending…','hi');
    var blobUrl=URL.createObjectURL(f);
    var img=new Image();
    img.onload=function(){
      var W=img.naturalWidth, H=img.naturalHeight;
      var scale=Math.min(1, MAX_SEND_PX/Math.max(W,H));
      var cW=Math.round(W*scale), cH=Math.round(H*scale);
      var canvas=document.createElement('canvas');
      canvas.width=cW; canvas.height=cH;
      canvas.getContext('2d').drawImage(img,0,0,cW,cH);
      var q=f.size>10*1024*1024 ? 0.82 : JPEG_QUALITY;
      canvas.toBlob(function(blob){
        URL.revokeObjectURL(blobUrl);
        if(!blob){ log('Compression failed for '+f.name+' — trying original','er'); cb(f); return; }
        var outName=f.name.replace(/\.(heic|heif|png|webp|bmp|tiff?)$/i,'.jpg');
        var out=new File([blob], outName, {type:'image/jpeg'});
        log('Compressed '+f.name+': '+fmt(f.size)+' → '+fmt(blob.size),'hi');
        cb(out);
      },'image/jpeg',q);
    };
    img.onerror=function(){
      URL.revokeObjectURL(blobUrl);
      log('Could not read '+f.name+' — trying original','er');
      cb(f);
    };
    img.src=blobUrl;
  }

  function _convertFile(f, cb){ _prepareFile(f, cb); }

  function setFiles(fileList){
    var raw=Array.from(fileList);
    if(!raw.length)return;
    S.origFiles = S.origFiles.concat(raw);
    S.newFiles = raw;
    var pending=raw.length, converted=[];
    raw.forEach(function(f,i){
      _prepareFile(f,function(cf){
        converted[i]=cf;
        if(--pending===0) _afterSetFiles(converted);
      });
    });
  }

  function _afterSetFiles(files){
    S.files = S.files.concat(files);
    /* Thumbnail strip — append only the newly added files */
try{
  var strip=document.getElementById('aluPrevStrip');
  if(strip){
    strip.style.display='flex';
    files.forEach(function(f){
      var url=URL.createObjectURL(f);
      var thumb=document.createElement('div');
      thumb.className='alu-prev-thumb';
      /* Blue dot to indicate newly added */
      thumb.innerHTML=
        '<img src="'+url+'" alt="">' +
        '<div class="alu-prev-thumb-label">'+f.name.replace(/\.[^.]+$/,'')+'</div>'+
        '<div class="alu-prev-thumb-new"></div>';
      strip.appendChild(thumb);
      /* Remove the "new" dot after 3 seconds */
      setTimeout(function(){
        var dot=thumb.querySelector('.alu-prev-thumb-new');
        if(dot) dot.style.display='none';
      },3000);
    });
  }
}catch(e){}
    var n=files.length;
    var totalSize=files.reduce(function(s,f){return s+f.size;},0);
    var hasLarge=files.some(function(f){return f.size>MAX_SEND_MB*1024*1024;});
    dz.querySelector('.alu-dz-txt').textContent=n===1?files[0].name:n+' images selected';
    var subMsg=n===1?fmt(files[0].size):n+' files ('+fmt(totalSize)+' total)';
    if(hasLarge) subMsg+=' — will auto-compress';
    var subEl=document.getElementById('aluDzSub')||dz.querySelector('.alu-dz-sub');
    subEl.textContent= S.files.length > files.length
      ? S.files.length+' images ready — drop more to add'
      : subMsg;
    $('aluBtn').disabled=false;
    log(n+' image'+(n>1?'s':'')+' ready'+(hasLarge?' — large files will be compressed before upload':''),'hi');
  }

  function setFile(f){ setFiles([f]); }

  document.querySelectorAll('.alu-chip').forEach(function(c){
    c.addEventListener('click',function(){
      if(c.dataset.k==='g'){c.classList.toggle('cg');S.g=c.classList.contains('cg');}
      else{c.classList.toggle('cm');S.m=c.classList.contains('cm');}
    });
  });

  function getMv(){
    if(!_mv){
      if(!window.customElements.get('model-viewer')){
        var conn=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
        var slow=conn&&(conn.effectiveType==='slow-2g'||conn.effectiveType==='2g'||conn.saveData===true);
        if(slow){
          log('3D preview unavailable on slow connection','er');
          return null;
        }
        var s=document.createElement('script');
        s.type='module';
        s.src='https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
        document.head.appendChild(s);
      }
      _mv=document.createElement('model-viewer');
      _mv.className='alu-mv';
      _mv.setAttribute('camera-controls','');
      _mv.setAttribute('auto-rotate','');
      _mv.setAttribute('auto-rotate-delay','1000');
      _mv.setAttribute('shadow-intensity','2.9');
      _mv.setAttribute('exposure','2.9');
      _mv.setAttribute('environment-image',_env);
      _mv.setAttribute('ar','');
      _mv.setAttribute('ar-modes','webxr scene-viewer quick-look');
      _mv.style.cssText='width:100%;height:100%;min-height:380px;display:block;--poster-color:#07070f';
      $('aluVbody').appendChild(_mv);
    }
    return _mv;
  }

  function loadModel(blob,label){
    if(_mvUrl){try{URL.revokeObjectURL(_mvUrl);}catch(e){}}
    _mvUrl=URL.createObjectURL(blob);
    $('aluVempty').style.display='none';
    var mv=getMv();
    if(!mv) return;
    mv.setAttribute('src',_mvUrl);mv.setAttribute('alt',label);
    setTimeout(function(){mv.style.display='none';mv.offsetHeight;mv.style.display='block';},50);
  }

  document.querySelectorAll('#aluEnvs .alu-preset').forEach(function(btn){
    btn.addEventListener('click',function(){
      document.querySelectorAll('#aluEnvs .alu-preset').forEach(function(b){b.classList.remove('on');});
      btn.classList.add('on');_env=btn.dataset.env;
      if(_mv)_mv.setAttribute('environment-image',_env);
    });
  });

  $('aluRotOn').addEventListener('click',function(){
    $('aluRotOn').classList.add('on');$('aluRotOff').classList.remove('on');
    if(_mv)_mv.setAttribute('auto-rotate','');
  });
  $('aluRotOff').addEventListener('click',function(){
    $('aluRotOff').classList.add('on');$('aluRotOn').classList.remove('on');
    if(_mv)_mv.removeAttribute('auto-rotate');
  });

  function openSSE(){
    _sid=Math.random().toString(36).slice(2);
    try{
      _sse=new EventSource(API+'/events/'+_sid);
      _sse.onmessage=function(ev){
        try{
          var e=JSON.parse(ev.data);
          if(e.type==='ping')return;
          if(e.type==='file_start'){log('Processing '+e.filename+'…','hi');addPixelLog('› Processing '+e.filename+'…');cyclePixelMsg('build');}
          if(e.type==='variant_done'){
            var pct=e.pct||Math.round(e.done/e.total*100);
            $('aluPpct').textContent=pct+'%';$('aluBar').style.width=pct+'%';
            $('aluMdone').textContent=e.done+'/'+e.total;
            $('aluMsize').textContent=(e.total_kb_out||0)+'KB';
            log('✓ '+e.filename+' '+e.glb_kb+'KB','ok');
            addPixelLog('✓ '+e.filename+' '+e.glb_kb+'KB','ok');
          setPixelProgress(pct);
          }
          if(e.type==='done'){
            stopTimer();$('aluSdot').className='alu-sdot';$('aluSbadge').textContent='DONE';
            $('aluMtime').textContent=e.elapsed_s+'s';
            $('aluPpct').textContent='100%';$('aluBar').style.width='100%';$('aluBar').classList.remove('go');
          }
          if(e.type==='error')log('✖ '+e.detail,'er');
        }catch(err){}
      };
      _sse.onerror=function(){};
    }catch(err){}
    return _sid;
  }

  function closeSSE(){if(_sse){_sse.close();_sse=null;}}

  function unzip(buf){
    var u8=new Uint8Array(buf),dv=new DataView(buf),out=[];
    var eocd=-1;
    for(var i=u8.length-22;i>=0;i--){if(dv.getUint32(i,true)===0x06054b50){eocd=i;break;}}
    if(eocd<0)throw new Error('Invalid ZIP response');
    var n=dv.getUint16(eocd+10,true),cd=dv.getUint32(eocd+16,true),p=cd;
    for(var e=0;e<n;e++){
      if(dv.getUint32(p,true)!==0x02014b50)break;
      var cs=dv.getUint32(p+20,true),fl=dv.getUint16(p+28,true);
      var xl=dv.getUint16(p+30,true),cl=dv.getUint16(p+32,true);
      var lo=dv.getUint32(p+42,true);
      var name=new TextDecoder().decode(u8.slice(p+46,p+46+fl));
      p+=46+fl+xl+cl;
      var lfl=dv.getUint16(lo+26,true),lxl=dv.getUint16(lo+28,true);
      out.push({name:name,data:u8.slice(lo+30+lfl+lxl,lo+30+lfl+lxl+cs)});
    }
    return out;
  }

  $('aluBtn').addEventListener('click',function(){
    if(S.busy||!S.files.length)return;
    if(!S.g&&!S.m){toast('Select at least one finish',false);return;}
    if(!API||API.length<8){toast('Railway URL not set in section settings',false);return;}

    S.busy=true;
    var btn=$('aluBtn');btn.disabled=true;btn.classList.add('run');
    showPixelOverlay();
    cyclePixelMsg('fetch');
    addPixelLog('› Preparing images…');
    setPixelProgress(3);
    IMG_KB=Math.round(S.files.reduce(function(s,f){return s+f.size;},0)/1024);
    var _pxImg=new Image();
    _pxImg.onload=function(){ buildPixelMap(_pxImg); };
    _pxImg.src=URL.createObjectURL(S.files[0]);
    startPixelCanvas();
    $('aluSdot').className='alu-sdot on';$('aluSbadge').textContent='RUNNING';
    $('aluPpct').textContent='0%';$('aluBar').style.width='0%';$('aluBar').classList.add('go');
    $('aluMdone').textContent='—';$('aluMsize').textContent='—';$('aluMtime').textContent='0s';
    var tabs=$('aluTabs');
    tabs.querySelectorAll('.alu-tab').forEach(function(t){t.classList.remove('g','m');});

    _t0=Date.now();stopTimer();
    _timer=setInterval(function(){
      if(_t0)$('aluMtime').textContent=((Date.now()-_t0)/1000).toFixed(1)+'s';
    },100);

    var sid=openSSE();
    log('Sending to server…','hi');

    var fd=new FormData();
    (S.newFiles&&S.newFiles.length?S.newFiles:S.files).forEach(function(f){ fd.append('files[]',f); });
    fd.append('glossy',S.g?'true':'false');
    fd.append('matte',S.m?'true':'false');
    fd.append('usdz','false');
    fd.append('session_id',sid);
    fd.append('metallic','0.9');
    fd.append('roughness_glossy','0.05');
    fd.append('roughness_matte','0.38');
    fd.append('thickness','0.003');
    fd.append('scale','1.0');

    var controller=new AbortController();
    var fetchTimeout=setTimeout(function(){controller.abort();},300000);

    fetch(API+'/generate',{method:'POST',body:fd,mode:'cors',credentials:'omit',signal:controller.signal})
      .then(function(res){
        clearTimeout(fetchTimeout);closeSSE();stopTimer();
        if(!res.ok){
          return res.text().then(function(t){
            if(t.trim().startsWith('<'))throw new Error('Server returned HTML — check Railway URL in settings');
            try{var j=JSON.parse(t);throw new Error(j.error||'Server error '+res.status);}
            catch(ex){if(ex.message&&!ex.message.startsWith('{'))throw ex;throw new Error('Server error '+res.status);}
          });
        }
        return res.arrayBuffer();
      })
      .then(function(buf){
        S.newFiles=[];
        var entries=unzip(buf);
        var glbs=entries.filter(function(e){return e.name.endsWith('.glb');});
        var totalKb=glbs.reduce(function(s,e){return s+(e.data.byteLength>>10);},0);

        $('aluSdot').className='alu-sdot';$('aluSbadge').textContent='DONE';
        $('aluPpct').textContent='100%';$('aluBar').style.width='100%';$('aluBar').classList.remove('go');
        $('aluMdone').textContent=glbs.length+'/'+glbs.length;
        $('aluMsize').textContent=totalKb+'KB';

        glbs.forEach(function(entry,i){
          var blob=new Blob([entry.data],{type:'model/gltf-binary'});
          var isG=entry.name.includes('_glossy');
          var tab=document.createElement('button');
          tab.className='alu-tab '+(isG?'g':'m');
          tab.textContent=isG?'● Glossy':'● Matte';
          (function(b,n,ig){
            tab.addEventListener('click',function(){
              tabs.querySelectorAll('.alu-tab').forEach(function(t){t.className='alu-tab';});
              tab.className='alu-tab '+(ig?'g':'m');
              loadModel(b,n);
            });
          })(blob,entry.name,isG);
          tabs.appendChild(tab);
          if(i===0){
            tabs.style.display='flex';
            loadModel(blob,entry.name);
            setTimeout(function(){
              if(!/iPhone|iPad|Android/i.test(navigator.userAgent)){
                $('aluVbody').scrollIntoView({behavior:'smooth',block:'start'});
              }
            },400);
          }
        });

        addPixelLog('✓ Ready — drag to explore','ok');
        setPixelProgress(100);
        cyclePixelMsg('ready');
        setTimeout(function(){ hidePixelOverlay(); }, 1200);
        log('✨ '+glbs.length+' model'+(glbs.length>1?'s':'')+' ready','ok');
        toast(glbs.length+' model'+(glbs.length>1?'s':'')+' ready — drag to explore');

        if(SHOW_EMAIL){
          var eb=document.getElementById('aluEmailBlock');
          if(eb) eb.style.display='flex';
        }

        if(SHOW_ATC){ buildBatchCards(S.files, glbs); }
        if(SHOW_EMAIL){
          var eb=document.getElementById('aluEmailBlock');
          if(eb) eb.style.display='flex';
        }

        setTimeout(function(){
          var v=document.getElementById('aluVbody');
          if(v) v.scrollIntoView({behavior:'smooth',block:'start'});
        },400);

        var floatCta=document.getElementById('aluFloatCta');
        if(floatCta) floatCta.style.display='none';

        if(S.files[0]){
          var reader=new FileReader();
          reader.onload=function(ev){
            S.imageBase64=ev.target.result;
          };
          reader.readAsDataURL(S.files[0]);
        }

        if(SHOW_PROOF){
          var pn=document.getElementById('aluProofNum');
          if(pn){
            var cur=parseInt(pn.textContent.replace(/,/g,''),10)||PROOF_BASE;
            pn.textContent=(cur+glbs.length).toLocaleString();
          }
        }
      })
      .catch(function(err){
        clearTimeout(fetchTimeout);closeSSE();stopTimer();
        $('aluSdot').className='alu-sdot';$('aluSbadge').textContent='ERROR';$('aluBar').classList.remove('go');
        var msg=err.message;
        if(err.name==='AbortError')msg='Request timed out — image may be too large';
        else if(msg.toLowerCase().includes('fetch'))msg='Cannot reach server — check Railway URL ('+API+')';
        log('✖ '+msg,'er');
        addPixelLog('✖ '+msg,'dim');
        toast(msg,false);
        setTimeout(function(){ hidePixelOverlay(); }, 2000);
      })
      .finally(function(){
        S.busy=false;btn.disabled=false;btn.classList.remove('run');
      });
  });

  var VARIANTS = {
    "MATTE|MEDIUM | 21 x 29.7 cm|Aluminium Rack":  47940561404056,
    "MATTE|MEDIUM | 21 x 29.7 cm|Magnetic Board":  48012265816216,
    "MATTE|LARGE | 29.7 x 42 cm|Aluminium Rack":   47940561338520,
    "MATTE|LARGE | 29.7 x 42 cm|Magnetic Board":   48012265783448,
    "MATTE|EXTRA LARGE | 42 x 59 cm|Aluminium Rack":48012265750680,
    "MATTE|VERY LARGE | 59 x 84 cm|Aluminium Rack": 48012265717912,
    "GLOSS|MEDIUM | 21 x 29.7 cm|Aluminium Rack":  48808261550232,
    "GLOSS|MEDIUM | 21 x 29.7 cm|Magnetic Board":  48808261583000,
    "GLOSS|LARGE | 29.7 x 42 cm|Aluminium Rack":   48808261615768,
    "GLOSS|LARGE | 29.7 x 42 cm|Magnetic Board":   48808261648536,
    "GLOSS|EXTRA LARGE | 42 x 59 cm|Aluminium Rack":48808261681304,
    "GLOSS|VERY LARGE | 59 x 84 cm|Aluminium Rack": 48808261714072
  };

  var atcBtn=document.getElementById('aluAtcBtn');
  if(atcBtn){
    atcBtn.addEventListener('click',function(){
      var size=(sizeSel?sizeSel.value:'').trim();
      if(!size){toast('Please select a size first',false);return;}
      var mountRadio=document.querySelector('input[name="aluMount"]:checked');
      var mount=mountRadio?mountRadio.value:'Aluminium Rack';
      var emailEl=document.getElementById('aluAtcEmail');
      var userEmail=emailEl?(emailEl.value||'').trim():'';
      var finishRadio=document.querySelector('input[name="aluFinish"]:checked');
      var finishKey=finishRadio?finishRadio.value:'GLOSS';
      var finishLabel=finishKey==='GLOSS'?'Glossy':'Matte';
      var imgName=S.files.length?S.files[0].name:'custom-image';
      var varKey=finishKey+'|'+size+'|'+mount;
      var variantId=VARIANTS[varKey];
      if(!variantId){ variantId=VARIANTS[finishKey+'|'+size+'|Aluminium Rack']; }
      if(!variantId){ toast('Sorry, that combination is not available',false); log('No variant found for: '+varKey,'er'); return; }
      var refId='ALU-'+Date.now().toString(36).toUpperCase()+'-'+Math.random().toString(36).slice(2,6).toUpperCase();
      atcBtn.disabled=true;
      atcBtn.textContent='Adding to cart…';

      function sendOrderEmails(imageUrl){
        var imgLine = imageUrl ? '\nImage: '+imageUrl : '\nImage: '+imgName;
        var params = {
          to_email: HQ_EMAIL, subject: '['+refId+'] New Order — Alumenarc',
          from_name: 'Alumenarc Studio',
          message: 'New order!\n\nRef: '+refId+'\nSize: '+size+'\nFinish: '+finishLabel+'\nMount: '+mount+'\nVariant ID: '+variantId+imgLine+'\nCustomer: '+(userEmail||'not provided'),
          image_name: imgName, image_url: imageUrl||'', user_email: userEmail, ref_id: refId,
        };
        sendEmail(params).then(function(){ console.log('HQ email sent OK'); }).catch(function(e){ console.error('HQ email failed:', e); });
      }

      var noteText='Design ref: '+refId+' | Image: '+imgName+' | '+finishLabel+' | '+size+' | '+mount;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variantId,quantity:1,properties:{'Design Ref':refId,'Image':imgName,'Finish':finishLabel,'Size':size,'Mount':mount}})})
      .then(function(){
        return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:noteText})});
      })
      .then(function(){
        var refEl=document.getElementById('aluAtcRef');
        if(refEl){ refEl.innerHTML='✓ Ref: <strong>'+refId+'</strong><br><small style="opacity:.6">Taking you to checkout…</small>'; refEl.style.display='block'; }
        atcBtn.style.display='none';
        toast('Going to checkout…');
        log('Ref '+refId+' — checkout','ok');

        function doEmailsThenRedirect(imageUrl){
          sendOrderEmails(imageUrl);
          if(userEmail){
            sendEmail({to_email:userEmail,subject:'Your Alumenarc Order — Ref: '+refId,from_name:'Alumenarc',message:'Your order reference: '+refId+'\nSize: '+size+'\nFinish: '+finishLabel+'\nMount: '+mount+'\n\nQuote this reference at checkout — it links to your design.',image_name:imgName,user_email:userEmail,ref_id:refId});
          }
          setTimeout(function(){ window.location.href='/checkout'; },2500);
        }

        var _origForEmail=S.origFiles.length?S.origFiles[0]:S.files[0];
        if(_origForEmail && API && API.length>8){
          var imgFd=new FormData();
          imgFd.append('image', _origForEmail);
          imgFd.append('ref', refId);
          var cloudTimeout=setTimeout(function(){ doEmailsThenRedirect(''); }, 8000);
          fetch(API+'/upload-image',{method:'POST',mode:'cors',credentials:'omit',body:imgFd})
            .then(function(r){return r.json();})
            .then(function(d){ clearTimeout(cloudTimeout); doEmailsThenRedirect(d.url||''); })
            .catch(function(e){ clearTimeout(cloudTimeout); doEmailsThenRedirect(''); });
        } else { doEmailsThenRedirect(''); }
      })
      .catch(function(err){
        atcBtn.disabled=false;
        atcBtn.textContent=window.AluConfig.atcBtn;
        toast('Could not add to cart — please try again',false);
        log('Cart error: '+(err.message||err),'er');
      });
    });
  }

  var emailSub=document.getElementById('aluEmailSub');
  var emailInp=document.getElementById('aluEmailInp');
  if(emailSub&&emailInp){
    emailSub.addEventListener('click',function(){
      var val=(emailInp.value||'').trim();
      if(!val||!val.includes('@')){toast('Enter a valid email',false);return;}
      emailSub.disabled=true; emailSub.textContent='Sending…';
      sendEmail({to_email:val,subject:'Your Alumenarc 3D Preview — Reminder',from_name:'Alumenarc Studio',message:'Hi! You generated a 3D metal poster preview. Come back and order: https://alumenarc.com',image_name:S.files.length?S.files[0].name:'',user_email:val})
      .then(function(){
        sendEmail({to_email:HQ_EMAIL,subject:'New Lead — Alumenarc Studio',from_name:'Alumenarc Studio',message:'Reminder signup:\nEmail: '+val+'\nImage: '+(S.files.length?S.files[0].name:'unknown'),image_name:S.files.length?S.files[0].name:'',user_email:val});
        emailInp.style.display='none'; emailSub.style.display='none';
        var thanks=document.getElementById('aluEmailThanks');
        if(thanks)thanks.style.display='block';
        toast('Reminder sent to '+val);
      }).finally(function(){ emailSub.disabled=false; });
    });
  }

  var SIZES_LIST=[
    {val:'MEDIUM | 21 x 29.7 cm',   label:'Medium (21×30 cm) — PKR 2,500'},
    {val:'LARGE | 29.7 x 42 cm',    label:'Large (30×42 cm) — PKR 3,700'},
    {val:'EXTRA LARGE | 42 x 59 cm',label:'Extra Large (42×59 cm) — PKR 6,999'},
    {val:'VERY LARGE | 59 x 84 cm', label:'Very Large (59×84 cm) — PKR 13,999'},
  ];

  var S_orders=[];

  function buildBatchCards(files, glbs){
    var bb=document.getElementById('aluBatchBlock');
    var pc=document.getElementById('aluPosterCards');
    if(!bb||!pc)return;
    pc.innerHTML='';
    S_orders=[];

    files.forEach(function(file, idx){
      var imgUrl='';
      try{imgUrl=URL.createObjectURL(file);}catch(e){}
      var _orig=S.origFiles[idx]||file;
      S_orders.push({file:file,origFile:_orig,finish:'GLOSS',size:'',mount:'Aluminium Rack'});

      var card=document.createElement('div');
      card.className='alu-poster-card';
      card.dataset.idx=idx;

      var sizeOpts=SIZES_LIST.map(function(s){ return '<div class="alu-dd-item" data-val="'+s.val+'">'+s.label+'</div>'; }).join('');
      var mountOpts=['<div class="alu-dd-item selected" data-val="Aluminium Rack">Aluminium Rack</div>','<div class="alu-dd-item" data-val="Magnetic Board">Magnetic Board</div>'].join('');

      card.innerHTML=[
        '<img class="alu-poster-thumb" src="'+imgUrl+'" alt="">',
        '<div class="alu-poster-body">',
          '<div class="alu-poster-name">'+file.name+'</div>',
          '<div class="alu-poster-opts">',
            '<div class="alu-poster-chips">',
              '<div class="alu-poster-chip on-g" data-finish="GLOSS">Glossy</div>',
              '<div class="alu-poster-chip" data-finish="MATTE">Matte</div>',
            '</div>',
            '<div class="alu-dd alu-card-size-dd">',
              '<button class="alu-dd-btn" type="button"><span class="alu-dd-val">Select size…</span><span class="alu-dd-arrow"></span></button>',
              '<div class="alu-dd-list">'+sizeOpts+'</div>',
            '</div>',
            '<div class="alu-dd alu-card-mount-dd">',
              '<button class="alu-dd-btn" type="button"><span class="alu-dd-val">Aluminium Rack</span><span class="alu-dd-arrow"></span></button>',
              '<div class="alu-dd-list">'+mountOpts+'</div>',
            '</div>',
          '</div>',
        '</div>',
        '<div class="alu-poster-remove" title="Remove">×</div>',
      ].join('');

      card.querySelectorAll('.alu-poster-chip').forEach(function(chip){
        chip.addEventListener('click',function(){
          card.querySelectorAll('.alu-poster-chip').forEach(function(c){ c.className='alu-poster-chip'; });
          var f=chip.dataset.finish;
          chip.classList.add(f==='GLOSS'?'on-g':'on-m');
          S_orders[idx].finish=f;
          updateOrderBtn();
        });
      });

      (function(){
        var dd=card.querySelector('.alu-card-size-dd');
        var btn=dd.querySelector('.alu-dd-btn');
        var list=dd.querySelector('.alu-dd-list');
        var val=dd.querySelector('.alu-dd-val');
        btn.addEventListener('click',function(e){ e.stopPropagation(); closeAllDropdowns(dd); btn.classList.toggle('open'); list.classList.toggle('open'); });
        list.querySelectorAll('.alu-dd-item').forEach(function(item){
          item.addEventListener('click',function(){
            list.querySelectorAll('.alu-dd-item').forEach(function(i){i.classList.remove('selected');});
            item.classList.add('selected'); val.textContent=item.textContent.replace('✓ ','');
            S_orders[idx].size=item.dataset.val; card.classList.toggle('selected',!!item.dataset.val);
            btn.classList.remove('open'); list.classList.remove('open'); updateOrderBtn();
          });
        });
      })();

      (function(){
        var dd=card.querySelector('.alu-card-mount-dd');
        var btn=dd.querySelector('.alu-dd-btn');
        var list=dd.querySelector('.alu-dd-list');
        var val=dd.querySelector('.alu-dd-val');
        btn.addEventListener('click',function(e){ e.stopPropagation(); closeAllDropdowns(dd); btn.classList.toggle('open'); list.classList.toggle('open'); });
        list.querySelectorAll('.alu-dd-item').forEach(function(item){
          item.addEventListener('click',function(){
            list.querySelectorAll('.alu-dd-item').forEach(function(i){i.classList.remove('selected');});
            item.classList.add('selected'); val.textContent=item.textContent.replace('✓ ','');
            S_orders[idx].mount=item.dataset.val; btn.classList.remove('open'); list.classList.remove('open');
          });
        });
      })();

      card.querySelector('.alu-poster-remove').addEventListener('click',function(){
        S_orders.splice(idx,1); card.remove();
        pc.querySelectorAll('.alu-poster-card').forEach(function(c,i){ c.dataset.idx=i; });
        updateOrderBtn();
      });

      pc.appendChild(card);
    });

    bb.style.display='flex';

    var applyBtn=document.getElementById('aluApplyAll');
    var applyPanel=document.getElementById('aluApplyPanel');
    if(applyBtn && applyPanel){
      applyBtn.onclick=function(){ applyPanel.style.display=applyPanel.style.display==='flex'?'none':'flex'; };
    }

    ['aluApplySizeDD','aluApplyMountDD'].forEach(function(ddId){
      var dd=document.getElementById(ddId); if(!dd)return;
      var btn=dd.querySelector('.alu-dd-btn');
      var list=dd.querySelector('.alu-dd-list');
      var val=dd.querySelector('.alu-dd-val');
      btn.addEventListener('click',function(e){ e.stopPropagation(); closeAllDropdowns(dd); btn.classList.toggle('open'); list.classList.toggle('open'); });
      list.querySelectorAll('.alu-dd-item').forEach(function(item){
        item.addEventListener('click',function(){
          list.querySelectorAll('.alu-dd-item').forEach(function(i){i.classList.remove('selected');});
          item.classList.add('selected'); val.textContent=item.textContent.replace('✓ ','');
          btn.classList.remove('open'); list.classList.remove('open');
        });
      });
    });

    var applyGo=document.getElementById('aluApplyGo');
    if(applyGo){
      applyGo.onclick=function(){
        var szDD=document.getElementById('aluApplySizeDD');
        var mtDD=document.getElementById('aluApplyMountDD');
        var szItem=szDD&&szDD.querySelector('.alu-dd-item.selected');
        var mtItem=mtDD&&mtDD.querySelector('.alu-dd-item.selected');
        var sz=szItem?szItem.dataset.val:'';
        var mt=mtItem?mtItem.dataset.val:'';
        pc.querySelectorAll('.alu-poster-card').forEach(function(card){
          var i=parseInt(card.dataset.idx,10);
          if(sz){ S_orders[i].size=sz; card.classList.add('selected'); }
          if(mt){ S_orders[i].mount=mt; }
        });
        updateOrderBtn();
        if(applyPanel) applyPanel.style.display='none';
        toast('Applied to all posters');
      };
    }
  }

  function updateOrderBtn(){
    var btn=document.getElementById('aluBatchOrderBtn'); if(!btn)return;
    var ready=S_orders.filter(function(o){return o.size;});
    var total=S_orders.length;
    btn.disabled=ready.length===0;
    btn.textContent=ready.length===0
      ? 'Select sizes to order'
      : ready.length===total
        ? '🛒 Order '+total+' poster'+(total>1?'s':'')+' → Checkout'
        : '🛒 Order '+ready.length+' of '+total+' posters → Checkout';
  }

  document.addEventListener('click',function(e){
    if(!e.target || e.target.id!=='aluBatchOrderBtn') return;
    var ready=S_orders.filter(function(o){return o.size;});
    if(!ready.length){toast('Select at least one size',false);return;}
    var btn=e.target;
    var userEmail=(document.getElementById('aluBatchEmail')||{}).value||'';
    userEmail=userEmail.trim();
    btn.disabled=true; btn.textContent='Adding to cart…';

    var items=[];
    var badVariant=false;
    ready.forEach(function(o){
      var vKey=o.finish+'|'+o.size+'|'+o.mount;
      var vid=VARIANTS[vKey];
      if(!vid){ vid=VARIANTS[o.finish+'|'+o.size+'|Aluminium Rack']; }
      if(!vid){ badVariant=true; return; }
      var refId='ALU-'+Date.now().toString(36).toUpperCase()+'-'+Math.random().toString(36).slice(2,6).toUpperCase();
      items.push({id:vid,quantity:1,refId:refId,file:o.file,finish:o.finish==='GLOSS'?'Glossy':'Matte',size:o.size,mount:o.mount,properties:{'Design Ref':refId,'Image':o.file.name,'Finish':o.finish==='GLOSS'?'Glossy':'Matte','Size':o.size,'Mount':o.mount}});
    });

    if(badVariant){toast('One or more size combinations not available',false);btn.disabled=false;updateOrderBtn();return;}

    var noteLines=items.map(function(it){ return it.refId+': '+it.file.name+' | '+it.finish+' | '+it.size+' | '+it.mount; });
    var cartNote='Alumenarc batch order\n'+noteLines.join('\n');

    function addNext(i){
      if(i>=items.length){
        fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:cartNote})}).then(function(){
          var refEl=document.getElementById('aluBatchRef');
          if(refEl){ refEl.innerHTML='✓ Added '+items.length+' poster'+(items.length>1?'s':'')+' to cart<br>'+items.map(function(it){return '<strong>'+it.refId+'</strong> — '+it.file.name;}).join('<br>'); refEl.style.display='block'; }
          btn.style.display='none'; toast('Going to checkout…');

          var prog=document.getElementById('aluUploadProgress');
          var progSteps=document.getElementById('aluUploadSteps');
          var progBar=document.getElementById('aluUploadBar');
          var progCount=document.getElementById('aluUploadCount');
          if(prog){ prog.style.display='flex'; }

          var stepEls=[];
          if(progSteps){
            progSteps.innerHTML='';
            items.forEach(function(it,i){
              var row=document.createElement('div');
              row.className='alu-upload-step';
              row.innerHTML='<div class="alu-upload-step-dot"></div><span>'+it.file.name+'</span>';
              progSteps.appendChild(row); stepEls.push(row);
            });
          }

          var urlMap={}, done=0, total=items.length;

          function onUploadDone(){
            done++;
            var pct=Math.round(done/total*100);
            if(progBar) progBar.style.width=pct+'%';
            if(progCount) progCount.textContent=done+' / '+total;
            if(done<total) return;

            sendEmail({to_email:HQ_EMAIL,subject:'[BATCH] '+items.length+' poster order — Alumenarc',from_name:'Alumenarc Studio',message:'New batch order — '+items.length+' poster'+(items.length>1?'s':'')+'\nCustomer: '+(userEmail||'not provided')+'\n\n'+items.map(function(it){ var url=urlMap[it.refId]||it.file.name; return '\nRef: '+it.refId+'\nSize: '+it.size+' | Finish: '+it.finish+' | Mount: '+it.mount+'\nImage: '+url+'\n'; }).join('\n---\n'),image_url:Object.values(urlMap).join(', '),image_name:items.map(function(it){return it.file.name;}).join(', '),user_email:userEmail,ref_id:items.map(function(it){return it.refId;}).join(', ')});

            if(prog) prog.style.display='none';
            setTimeout(function(){window.location.href='/checkout';},1000);
          }

          items.forEach(function(it,i){
            if(stepEls[i]) stepEls[i].className='alu-upload-step active';
            var imgFd=new FormData();
            imgFd.append('image', it.origFile||it.file);
            imgFd.append('ref', it.refId);
            fetch(API+'/upload-image',{method:'POST',mode:'cors',credentials:'omit',body:imgFd})
              .then(function(r){return r.json();})
              .then(function(d){ urlMap[it.refId]=d.url||''; if(stepEls[i]) stepEls[i].className='alu-upload-step done'; onUploadDone(); })
              .catch(function(){ urlMap[it.refId]=''; if(stepEls[i]) stepEls[i].className='alu-upload-step err'; onUploadDone(); });
          });

          if(userEmail){
            sendEmail({to_email:userEmail,subject:'Your Alumenarc Order — '+items.length+' poster'+(items.length>1?'s':''),from_name:'Alumenarc',message:'Your order:\n'+noteLines.join('\n')+'\n\nQuote these references if you contact us.',user_email:userEmail,image_name:items.map(function(it){return it.file.name;}).join(', '),ref_id:items.map(function(it){return it.refId;}).join(', ')});
          }
        });
        return;
      }
      var it=items[i];
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:it.id,quantity:1,properties:it.properties})})
        .then(function(){ addNext(i+1); })
        .catch(function(err){ toast('Cart error on item '+(i+1)+': '+err.message,false); btn.disabled=false; updateOrderBtn(); });
    }
    addNext(0);
  });

  /* Keep Railway warm */
  var _apiOnline = null;

  function _updateStatus(online){
    if(_apiOnline === online) return;
    _apiOnline = online;
    var btn = $('aluBtn');
    var dz  = $('aluDz');
    if(online){
      if(btn) btn.title = '';
      if(dz)  dz.title = '';
      var banner = document.getElementById('aluOfflineBanner');
      if(banner) banner.style.display = 'none';
    } else {
      var banner = document.getElementById('aluOfflineBanner');
      if(!banner){
        banner = document.createElement('div');
        banner.id = 'aluOfflineBanner';
        banner.style.cssText = ['background:rgba(255,71,87,.12)','border:1px solid rgba(255,71,87,.3)','border-radius:8px','padding:10px 14px','font-family:var(--mn)','font-size:12px','color:#ff4757','text-align:center','animation:efadein .3s ease'].join(';');
        banner.innerHTML = '⚠ Server waking up — please wait a moment…';
        if(btn && btn.parentNode) btn.parentNode.insertBefore(banner, btn);
      }
      banner.style.display = 'block';
    }
  }

  function _ping(){
    if(!API || API.length < 8) return;
    fetch(API+'/health', {mode:'cors', credentials:'omit', cache:'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(){ _updateStatus(true); })
      .catch(function(){
        _updateStatus(false);
        setTimeout(_ping, 10000);
      });
  }

  if(API && API.length > 8){
    _ping();
    setInterval(_ping, 240000);
  }

})();